import { create } from 'zustand';
import { getComponentStore } from '../../../../utils/componentStoreRegistry';
import SequentialFormContainer from '../../SequentialFormContainer';

const getEmptyState = () => ({
  loaded: false,
  Statement: {
    Statement: {
      type: 'IF',
      content: {
        Condition: [
          {
            operators: [
              {
                logic: undefined,
                key: '',
                function: 'EQUAL',
                value: '',
              },
            ],
            then: {
              Statement: {
                type: 'VALUE',
                content: true,
              },
            },
          },
          {
            then: {
              Statement: {
                type: 'VALUE',
                content: false,
              },
            },
          },
        ],
      },
    },
  },
  AnswerList: [
    {
      ConditionList: [
        {
          HasSelected: false,
          dataAnswer: [],
        },
      ],
    },
  ],
});

const createFormRequiredStore = () => create((set, get) => ({
  ...getEmptyState(),

  setStatement: (Statement) => {
    set({ Statement });
  },

  setFormConditional: (Statement) => {
    if (Statement.Statement) {
      const data = JSON.parse(JSON.stringify(Statement.Statement.content.Condition));
      const List = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let obj = [];
          if (data[i].operators) {
            for (let j = 0; j < data[i].operators.length; j++) {
              obj.push({ HasSelected: false, dataAnswer: [] });
            }
            List.push({ ConditionList: obj });
          }
        }
        set({ AnswerList: List, Statement });
        for (let i = 0; i < data.length; i++) {
          if (data[i].operators) {
            for (let j = 0; j < data[i].operators.length; j++) {
              get().checkHasSelected(data[i].operators[j].key, i, j);
            }
          }
        }
        return;
      }
    }
    set({ Statement });
  },

  checkHasSelected: (key, indexStatement, indexCondition) => {
    const data = JSON.parse(JSON.stringify(SequentialFormContainer.dataQuestion));
    const filterData = data.filter((ele) => ele.config.key == key);
    if (filterData[0] != null && filterData[0] != undefined && filterData[0] != '') {
      const AnswerList = JSON.parse(JSON.stringify(get().AnswerList));
      if (
        filterData[0] &&
        (filterData[0].type == 4 || filterData[0].type == 5 || filterData[0].type == 10)
      ) {
        AnswerList[indexStatement].ConditionList[indexCondition].HasSelected = true;
        AnswerList[indexStatement].ConditionList[indexCondition].dataAnswer =
          filterData[0].config.answer_list;
      } else {
        AnswerList[indexStatement].ConditionList[indexCondition].HasSelected = false;
      }
      set({ AnswerList });
    }
  },

  addCondition: (indexStatement) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    const AnswerList = JSON.parse(JSON.stringify(get().AnswerList));
    Statement.Statement.content.Condition[indexStatement].operators.push({
      logic: 'OR',
      key: '',
      function: 'EQUAL',
      value: '',
    });
    AnswerList[indexStatement].ConditionList.push({ HasSelected: false, dataAnswer: [] });
    set({ Statement, AnswerList });
  },

  addStatement: () => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    const AnswerList = JSON.parse(JSON.stringify(get().AnswerList));
    const obj = {
      operators: [{ logic: 'OR', key: '', function: 'EQUAL', value: '' }],
      then: { Statement: { type: 'VALUE', content: true } },
    };
    AnswerList.push({ ConditionList: [{ HasSelected: false, dataAnswer: [] }] });
    const { Condition } = Statement.Statement.content;
    Condition.splice(Condition.length - 1, 0, obj);
    set({ Statement, AnswerList });
  },

  removeCondition: (indexStatement, indexCondition) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    const AnswerList = JSON.parse(JSON.stringify(get().AnswerList));
    Statement.Statement.content.Condition[indexStatement].operators.splice(indexCondition, 1);
    AnswerList[indexStatement].ConditionList.splice(indexCondition, 1);
    set({ Statement, AnswerList });
  },

  removeStatement: (indexStatement) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    const AnswerList = JSON.parse(JSON.stringify(get().AnswerList));
    Statement.Statement.content.Condition.splice(indexStatement, 1);
    AnswerList.splice(indexStatement, 1);
    set({ Statement, AnswerList });
  },

  setThenContent: (content, indexStatement) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    Statement.Statement.content.Condition[indexStatement].then.Statement.content = content;
    set({ Statement });
  },

  setElseContent: (content) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    Statement.Statement.content.else.Statement.content = content;
    set({ Statement });
  },

  setCondition: (content, indexStatement, index, type) => {
    const Statement = JSON.parse(JSON.stringify(get().Statement));
    switch (type) {
      case 'logic':
        Statement.Statement.content.Condition[indexStatement].operators[index].logic = content;
        set({ Statement });
        return;
      case 'key':
        Statement.Statement.content.Condition[indexStatement].operators[index].key = content;
        set({ Statement });
        get().checkHasSelected(content, indexStatement, index);
        return;
      case 'function':
        Statement.Statement.content.Condition[indexStatement].operators[index].function = content;
        set({ Statement });
        return;
      case 'value':
        Statement.Statement.content.Condition[indexStatement].operators[index].value = content;
        set({ Statement });
        return;
    }
  },

  initialiseEmpty: () => {
    set({ ...getEmptyState(), loaded: false });
  },

  getTemplate: () => ({
    conditionPredertermine: get().conditionPredertermine,
    AnswerList: [],
  }),
}));

export function getFormRequiredStore(componentId) {
  return getComponentStore('sf_form_required', componentId, createFormRequiredStore);
}

const useFormRequiredStore = createFormRequiredStore();
export default useFormRequiredStore;
